var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcnMintOptionTimith = function SvgIcnMintOptionTimith(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 12c0-6.627-5.373-12-12-12S0 5.373 0 12s5.373 12 12 12 12-5.373 12-12Z",
    fill: "#F3FBFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.521 8 6 8.857l.521.883 3.831.563.124-1.43L6.521 8ZM13.91 9.63a.171.171 0 0 0-.175.072c-.041.067-.083.175-.078.371a3.46 3.46 0 0 0 .005.191c.003.064.006.127.006.191v.346l3.04.393s.868.16 1.173-.79l.118-.868c.006-.03-.02-.062-.056-.062h-1.007c-.031 0-.057.026-.057.052l-.01.718-2.959-.615Z",
    fill: "#28A9E1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.865 8h4.993c.624 0 1.001.805 1.11 1.069a.06.06 0 0 1-.057.082H14.1c-.95.228-.734.971-.734.971l.217 5.937c0 .031-.01.057-.03.078l-1.601 1.518c-.036.036-.098.036-.14 0l-1.626-1.529c-.02-.02-.036-.051-.03-.082l.598-6.893C10.77 8.124 11.865 8 11.865 8Z",
    fill: "#28A9E1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 .5C18.351.5 23.5 5.649 23.5 12S18.351 23.5 12 23.5.5 18.351.5 12 5.649.5 12 .5Z",
    stroke: "#28A9E1"
  })));
};
export default SvgIcnMintOptionTimith;